"use client"

import {useRef} from 'react';
import dynamic from "next/dynamic";
import {observer} from "mobx-react";

import Breadcrumbs from "../../components/misc/Breadcrumbs";
import {sb_pageSave} from "./PageEditor";
import styles from "../styles/MainGridPage.module.scss";
import {useStores} from "../../stores/useStores";
import {useTranslateClassName} from "../../hooks/useTranslateClassName";
import classNames from "classnames";

const ToolDrawerPage = dynamic(
    () => import('./ToolDrawerPage'),
    { ssr: false }
);

const PageBlockPage = observer((props: {
}) => {
    const {organizationStore, userStore, interfaceStore, i18nStore} = useStores();
    const pageBodyRef = useRef(null);
    const isEditing = userStore.isEditor && interfaceStore.isEditingPage;
    const {user, page} = organizationStore.currentOrganization;
    const translateClassName = useTranslateClassName();

    const pageSaveFunction = () => {
        sb_pageSave(i18nStore.currentOrgSupportedLocale, organizationStore.currentOrganization.id);
    }

    let content;
    if (!userStore.viewer) {
        content =
            <h3 className="text-danger"><b>This is a private page that you do not have permission to view.</b></h3>
    } else if (page === null || page.content === null) {
        if (user) {
            content = <div id="pageBody" className="sb-page-body scoped-content-builder" ref={pageBodyRef}><p>By {user.fname} {user.lname}</p></div>
        } else {
            content =
                <div id="pageBody" className="sb-page-body scoped-content-builder" ref={pageBodyRef}><p>Start typing here or drag content blocks from the toolbar on the right to edit this page.</p>
                </div>;
        }
    } else {
        content = <div id="pageBody" className="sb-page-body scoped-content-builder" ref={pageBodyRef} dangerouslySetInnerHTML={{__html: page.content}}/>;
    }

    if (!organizationStore.currentOrganization || organizationStore.currentOrganization.deleted) {
        return <div id="sb-main-content" className="sb-page-container sb-page-width sb-content-width sb-main-content">
            <div className="sb-page-header">
                <h2 id="pageTitle" style={{textAlign: "center"}}>
                    <span>The page '{organizationStore.currentOrganization.title || organizationStore.currentOrganization.id}' does not exist</span>
                </h2>
            </div>
        </div>
    }

    return <>
        <div id="sb-main-content" className={classNames("sb-page-container", "sb-page-width", "sb-content-width", "sb-main-content", "clearfix", translateClassName)}
             data-id={organizationStore.currentOrganization.id}>
            <div className={`${styles.classroomHeaderTopBlock} ${styles.pageTop}`}>
                <div className="row">
                    <div className="col-sm-12">
                        <Breadcrumbs breadcrumbs={organizationStore.currentOrganization.breadcrumbs} editable={true}/>
                    </div>
                </div>
            </div>
            <div className="sb-page-header">
                <h2 id="pageTitle" className="pull-left notranslate"
                    contentEditable={isEditing}>{organizationStore.currentOrganization.title}</h2>
                {isEditing && <div className="pull-right">
                    <div className="pull-left sb-ada-page-errors-count">
                    </div>
                    <button type="button" id="pageSave" className="btn btn-primary pull-right"
                            onClick={pageSaveFunction}>Save
                        changes
                    </button>
                </div>}
            </div>
            <div contentEditable={isEditing}>
                {content}
            </div>
            <div className="panel panel-default sb-ada-page-errors-table">
                <div className="panel-heading">
                    ADA Compliance Errors
                    <span className="label label-danger pull-right">0</span>
                </div>
                <div className="panel-body">
                    <div className="table-responsive"/>
                </div>
                <div className="panel-footer">Need help fixing these errors? <a href="javascript:void(0);"
                                                                                onClick={() =>$('#btn-trigger-help-window').click()}>Contact us!</a></div>
            </div>
        </div>
        {
            // The ContentBuilder script tags below are required because the actual scripts loaded inside the
            // ToolDrawerPage component search the DOM for entries named "contentbuilder.js" and "saveimages.js"
            // even though the scripts are bundled using Webpack/Next.
            userStore.editor && <ToolDrawerPage pageBodyRef={pageBodyRef}/>
        }
    </>
});

export default PageBlockPage;
